// @flow
import React from 'react';
import {ActivityIndicator} from 'trpc-react-native-ui';
import {CardElement} from '@stripe/react-stripe-js';
import './CheckoutForm.css';
import theme from '../../../../../../theme-config';

const styles = {
  container: {
    margin: 'auto',
    width: '75%',
  },
};

type Props = {
  elements: any,
  onStripeSuccess: Function,
  onStripeError: Function,
  cardDetailsText: string,
  confirmOrderText: string,
  stripe: any,
};

type State = {
  isSubmitting: boolean,
};

class CheckoutForm extends React.Component<Props, State> {
  state = {
    isSubmitting: false,
  };

  handleSubmit = (ev: Event) => {
    ev.preventDefault();

    const {elements, stripe, onStripeSuccess, onStripeError} = this.props;

    if (!elements || !stripe || this.state.isSubmitting) {
      return;
    }

    this.setState({isSubmitting: true});

    const cardElement = elements.getElement(CardElement);

    stripe
      .createPaymentMethod({type: 'card', card: cardElement})
      .then(response => onStripeSuccess(response.paymentMethod))
      .catch(err => onStripeError(err));
  };

  focusInputWhenReady = (el: any) => el.focus();

  render() {
    return (
      <div id="stripe-checkout-form" style={styles.container}>
        <form onSubmit={this.handleSubmit}>
          <label>
            {this.props.cardDetailsText}
            <CardElement
              onReady={this.focusInputWhenReady}
              options={{
                hidePostalCode: true,
                style: {
                  base: {
                    fontSize: `${theme.ui.font.size.large}px`,
                  },
                },
                hideIcon: false,
                preferredNetwork: ['mastercard', 'visa', 'cartes_bancaires'],
              }}
            />
          </label>
          <button disabled={this.state.isSubmitting}>
            {this.state.isSubmitting ? (
              <ActivityIndicator color="white" />
            ) : (
              this.props.confirmOrderText
            )}
          </button>
        </form>
      </div>
    );
  }
}

export default CheckoutForm;
